<template>
  <Badge :variant="statusColorMap.get(props.showingStatus)" :label="props.showingStatus" size="small" />
</template>

<script setup lang="ts">
import { Badge, BadgeVariant } from '@tallo/design-system';

import { ShowingStatus } from '../interfaces/showing-status.enum';

const props = defineProps<{ showingStatus: ShowingStatus }>();
const statusColorMap = new Map<ShowingStatus, BadgeVariant>([
  [ShowingStatus.CONFIRMED, 'green'],
  [ShowingStatus.PENDING, 'yellow'],
  [ShowingStatus.COMPLETED, 'blue'],
  [ShowingStatus.CANCELED, 'grey'],
  [ShowingStatus.DECLINED, 'red'],
  [ShowingStatus.EXPIRED, 'grey'],
]);
</script>

<style scoped lang="scss"></style>
